export const REMOVE_LOGGER_SCREENS = {
    ENTER_ASSET_OR_LOGGER_CODE: 'ENTER_ASSET_OR_LOGGER_CODE',
    SCAN_CODE: 'SCAN_CODE',
    CHECK_CODE: 'CHECK_CODE',
    REMOVAL_SUCCESS: 'REMOVAL_SUCCESS',
};
